// Registry of the shared grammar explanation components.
//
// Topic lesson JSONs reference a grammar point by slug
// ({ type: "grammarexplanation", grammarPoint: "passive" }) and
// TopicsRouter looks the component up here, so a topic page and its
// matching grammar-exercises page always show the same explanation.
//
// Keys are the grammar-point slugs used by the grammar lesson pages
// (src/Mainpages/Grammar-Exercises/grammar-pages/*).
import AdjAdvExplanation from '../../Grammar-Exercises/components/explanations/adj-adv-explanation';
import CauseEffectExplanation from '../../Grammar-Exercises/components/explanations/cause-effect-explanation';
import CollocationsExplanation from '../../Grammar-Exercises/components/explanations/collocations-explanation';
import ComparisonExplanation from '../../Grammar-Exercises/components/explanations/comparison-explanation';
import ComparisonsExplanation from '../../Grammar-Exercises/components/explanations/comparisons-explanation';
import ConditionalsExplanation from '../../Grammar-Exercises/components/explanations/conditionals-explanation';
import DependentPrepositionsExplanation from '../../Grammar-Exercises/components/explanations/dependent-prepositions-explanation';
import DescriptiveAdjectivesExplanation from '../../Grammar-Exercises/components/explanations/descriptive-adjectives-explanation';
import DeviceVerbsExplanation from '../../Grammar-Exercises/components/explanations/device-verbs-explanation';
import EdIngExplanation from '../../Grammar-Exercises/components/explanations/ed-ing-explanation';
import FirstCondExplanation from '../../Grammar-Exercises/components/explanations/first-cond-explanation';
import FutureExplanation from '../../Grammar-Exercises/components/explanations/future-explanation';
import GerundsExplanation from '../../Grammar-Exercises/components/explanations/gerunds-explanation';
import GerundsInfinitivesExplanation from '../../Grammar-Exercises/components/explanations/gerunds-infinitives-explanation';
import IndirectSpeechExplanation from '../../Grammar-Exercises/components/explanations/indirect-speech-explanation';
import InfinitivesExplanation from '../../Grammar-Exercises/components/explanations/infinitives-explanation';
import IntroductionsExplanation from '../../Grammar-Exercises/components/explanations/introductions-explanation';
import LinkingWordsExplanation from '../../Grammar-Exercises/components/explanations/linking-words-explanation';
import MixedConditionalsExplanation from '../../Grammar-Exercises/components/explanations/mixed-conditionals-explanation';
import ModalsDeductionExplanation from '../../Grammar-Exercises/components/explanations/modals-deduction-explanation';
import CanExplanation from '../../Grammar-Exercises/components/explanations/can-explanation';
import ModalsObligationExplanation from '../../Grammar-Exercises/components/explanations/modals-obligation-explanation';
import MoneyIdiomsExplanation from '../../Grammar-Exercises/components/explanations/money-idioms-explanation';
import PassiveExplanation from '../../Grammar-Exercises/components/explanations/passive-explanation';
import PassiveBeingExplanation from '../../Grammar-Exercises/components/explanations/passive-being-explanation';
import PassiveGetExplanation from '../../Grammar-Exercises/components/explanations/passive-get-explanation';
import PassiveReportingExplanation from '../../Grammar-Exercises/components/explanations/passive-reporting-explanation';
import PastContinuousExplanation from '../../Grammar-Exercises/components/explanations/past-continuous-explanation';
import PastHabitsExplanation from '../../Grammar-Exercises/components/explanations/past-habits-explanation';
import PerfectPastExplanation from '../../Grammar-Exercises/components/explanations/perfect-past-explanation';
import PresentContinuousExplanation from '../../Grammar-Exercises/components/explanations/present-continuous-explanation';
import PresentPerfectExplanation from '../../Grammar-Exercises/components/explanations/present-perfect-explanation';
import ProvideVerbExplanation from '../../Grammar-Exercises/components/explanations/provide-verb-explanation';
import PunctuationExplanation from '../../Grammar-Exercises/components/explanations/punctuation-explanation';
import RelativeClausesExplanation from '../../Grammar-Exercises/components/explanations/relative-clauses-explanation';
import ReportedSpeechExplanation from '../../Grammar-Exercises/components/explanations/reported-speech-explanation';
import SecondCondExplanation from '../../Grammar-Exercises/components/explanations/second-cond-explanation';
import SenseVerbsExplanation from '../../Grammar-Exercises/components/explanations/sense-verbs-explanation';
import SimpContExplanation from '../../Grammar-Exercises/components/explanations/simp-cont-explanation';
import SimplePastExplanation from '../../Grammar-Exercises/components/explanations/simple-past-explanation';
import SimplePresentExplanation from '../../Grammar-Exercises/components/explanations/simple-present-explanation';
import SoEnoughExplanation from '../../Grammar-Exercises/components/explanations/so-enough-explanation';
import SomeAnyExplanation from '../../Grammar-Exercises/components/explanations/some-any-explanation';
import SuggestExplanation from '../../Grammar-Exercises/components/explanations/suggest-explanation';
import TenseExplanation from '../../Grammar-Exercises/components/explanations/tense-explanation';
import ThirdCondExplanation from '../../Grammar-Exercises/components/explanations/third-cond-explanation';
import ToBePastExplanation from '../../Grammar-Exercises/components/explanations/to-be-past-explanation';
import ToBePresentExplanation from '../../Grammar-Exercises/components/explanations/to-be-present-explanation';
import UnlessExplanation from '../../Grammar-Exercises/components/explanations/unless-explanation';
import UsedToExplanation from '../../Grammar-Exercises/components/explanations/used-to-explanation';
import WishExplanation from '../../Grammar-Exercises/components/explanations/wish-explanation';
import WordFormsExplanation from '../../Grammar-Exercises/components/explanations/word-forms-explanation';
import ZeroConditionalExplanation from '../../Grammar-Exercises/components/explanations/zero-conditional-explanation';

const grammarExplanations = {
  'adj-adv': AdjAdvExplanation,
  'cause-effect': CauseEffectExplanation,
  collocations: CollocationsExplanation,
  comparison: ComparisonExplanation,
  comparisons: ComparisonsExplanation,
  conditionals: ConditionalsExplanation,
  'dependent-prepositions': DependentPrepositionsExplanation,
  'descriptive-adjectives': DescriptiveAdjectivesExplanation,
  'device-verbs': DeviceVerbsExplanation,
  'ed-ing': EdIngExplanation,
  'first-cond': FirstCondExplanation,
  future: FutureExplanation,
  gerunds: GerundsExplanation,
  'gerunds-infinitives': GerundsInfinitivesExplanation,
  'indirect-speech': IndirectSpeechExplanation,
  infinitives: InfinitivesExplanation,
  introductions: IntroductionsExplanation,
  'linking-words': LinkingWordsExplanation,
  'mixed-conditionals': MixedConditionalsExplanation,
  can: CanExplanation,
  'modals-deduction': ModalsDeductionExplanation,
  'modals-obligation': ModalsObligationExplanation,
  'money-idioms': MoneyIdiomsExplanation,
  passive: PassiveExplanation,
  'passive-being': PassiveBeingExplanation,
  'passive-get': PassiveGetExplanation,
  'passive-reporting': PassiveReportingExplanation,
  'past-continuous': PastContinuousExplanation,
  'past-habits': PastHabitsExplanation,
  'perfect-past': PerfectPastExplanation,
  'present-continuous': PresentContinuousExplanation,
  'present-perfect': PresentPerfectExplanation,
  'provide-verb': ProvideVerbExplanation,
  punctuation: PunctuationExplanation,
  'relative-clauses': RelativeClausesExplanation,
  'reported-speech': ReportedSpeechExplanation,
  'second-cond': SecondCondExplanation,
  'sense-verbs': SenseVerbsExplanation,
  'simp-cont': SimpContExplanation,
  'simple-past': SimplePastExplanation,
  'simple-present': SimplePresentExplanation,
  'so-enough': SoEnoughExplanation,
  'some-any': SomeAnyExplanation,
  suggest: SuggestExplanation,
  tense: TenseExplanation,
  'third-cond': ThirdCondExplanation,
  'to-be-past': ToBePastExplanation,
  'to-be-present': ToBePresentExplanation,
  unless: UnlessExplanation,
  'used-to': UsedToExplanation,
  wish: WishExplanation,
  'word-forms': WordFormsExplanation,
  'zero-conditional': ZeroConditionalExplanation,
};

export default grammarExplanations;
